module.exports = __webpack_public_path__ + "static/media/3_2_karthic_bala.1540f72.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/3_2_karthic_bala.mp3
// module id = 2Yuw
// module chunks = 1